import { Pipe, PipeTransform } from '@angular/core';
import { CloudinaryImage } from '@cloudinary/url-gen';
import { ImageHelperService } from '../../services/catalog/image-helper.service';
import { Product } from '@lobos/library';

@Pipe({
  name: 'labelImage',
})
export class LabelImagePipe implements PipeTransform {
  constructor(private imageHelperService: ImageHelperService) {}

  transform(product: Product): CloudinaryImage {
    return this.imageHelperService.getLabelImage(product.oResources)!;
  }
}
